import { createContext, useContext, ReactNode, useState } from "react";

interface FilterContextType {
  selectedNetwork: string;
  phoneNumber: string;
  startDate: string;
  endDate: string;
  company: string;
  appliedNetwork: string;
  appliedPhoneNumber: string;
  appliedStartDate: string;
  appliedEndDate: string;
  appliedCompany: string;
  setSelectedNetwork: (value: string) => void;
  setPhoneNumber: (value: string) => void;
  setStartDate: (value: string) => void;
  setEndDate: (value: string) => void;
  setCompany: (value: string) => void;
  handleFilter: () => void;
  handleReset: () => void;
  hasActiveFilters: boolean;
}

const FilterContext = createContext<FilterContextType | undefined>(undefined);

export const FilterProvider = ({ children }: { children: ReactNode }) => {
  const [selectedNetwork, setSelectedNetwork] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [company, setCompany] = useState("");
  const [appliedNetwork, setAppliedNetwork] = useState("");
  const [appliedPhoneNumber, setAppliedPhoneNumber] = useState("");
  const [appliedStartDate, setAppliedStartDate] = useState("");
  const [appliedEndDate, setAppliedEndDate] = useState("");
  const [appliedCompany, setAppliedCompany] = useState("");

  const handleFilter = () => {
    setAppliedNetwork(selectedNetwork);
    setAppliedPhoneNumber(phoneNumber);
    setAppliedStartDate(startDate);
    setAppliedEndDate(endDate);
    setAppliedCompany(company);
  };

  const handleReset = () => {
    setSelectedNetwork("");
    setPhoneNumber("");
    setStartDate("");
    setEndDate("");
    setCompany("");
    setAppliedNetwork("");
    setAppliedPhoneNumber("");
    setAppliedStartDate("");
    setAppliedEndDate("");
    setAppliedCompany("");
  };

  const hasActiveFilters = !!(
    appliedNetwork ||
    appliedPhoneNumber ||
    appliedStartDate ||
    appliedEndDate ||
    appliedCompany
  );

  return (
    <FilterContext.Provider
      value={{
        selectedNetwork,
        phoneNumber,
        startDate,
        endDate,
        company,
        appliedNetwork,
        appliedPhoneNumber,
        appliedStartDate,
        appliedEndDate,
        appliedCompany,
        setSelectedNetwork,
        setPhoneNumber,
        setStartDate,
        setEndDate,
        setCompany,
        handleFilter,
        handleReset,
        hasActiveFilters,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("useFilterContext must be used within a FilterProvider");
  }
  return context;
};
